import {
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router,
} from "@angular/router";
import { Injectable } from "@angular/core";
import { AuthService } from "../../services/auth.service";

@Injectable({
  providedIn: "root",
})
export class AuthGaurd {
  constructor(private route: Router, private authService: AuthService) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean {
    const role = this.authService.getRole();

    if (!role) {
      this.route.navigate(["login"]);
      return false;
    }
    if (role === "guest") {
      this.route.navigate(["register"]);
      return false;
    }
    if (role === "Pending") {
      this.route.navigate(["pending"]);
      return false;
    }
    if (role === "ServiceProvider" && state.url !== "/provider-dash") {
      this.route.navigate(["/provider-dash"]);
      return false;
    }
    if (
      role === "IntegrationPartner" &&
      !state.url.startsWith("/partner")
    ) {
      this.route.navigate(["/partner-dashboard"]);
      return false;
    }
    if (role === "SuperAdmin" && state.url !== "") {
      this.route.navigate(["/admin-dash/dashboard"]);
      return false;
    }

    return true;
  }
}
